import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('netlify'),
  requiresOAuthFlow: true,
  avatarPath: avatars.netlify,
  logoPath: logos.netlify
});
